import { Component, Inject, OnInit } from "@angular/core";
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { IItemSolicitacaoTecnicaModel } from "./../../../../models/item-solicitacao-tecnica.model";
import { AcessoCidadaoService } from "./../../../../services/acesso-cidadao.service";
import { SolicitacaoTecnicaService } from "./../../../../services/solicitacao-tecnica.service";
import { BaseListComponent } from "./../../../../shared/components/base-list/base-list.component";
import { IResponsavelModel } from "./../../../../models/responsaveis.model";


import Swal from "sweetalert2";

@Component({
	selector: "app-modal-delegar-item",
	templateUrl: "./modal-delegar-item.component.html",
})
export class ModalDelegarItemComponent
	extends BaseListComponent
	implements OnInit {
	constructor(
		public matDialog: MatDialog,
		private dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public data,
		private acessoCidadaoService: AcessoCidadaoService,
		private solicitacaoTecnicaService: SolicitacaoTecnicaService
	) {
		super();
		this.item = data.item;
		this.responsavelDelegado = this.item?.responsavelId;
		this.idUnidadeGestora = data.idUnidadeGestora;
	}

	public responsavelDelegado: any;
	public item: IItemSolicitacaoTecnicaModel;
	public responsaveis = [] as IResponsavelModel[];
	public responsavelDelegacao = "";
	public idUnidadeGestora: number;

	ngOnInit(): void {

		this.obterResponsaveis(this.idUnidadeGestora);
	}

	public obterResponsaveis(id: any) {

		this.solicitacaoTecnicaService.obterResponsaveis(id).then((res) => {
			if (res.sucesso) {
				this.responsaveis = res.dados;
				let responsavelEncontrado = this.responsaveis.find((r) => r.value == this.responsavelDelegado)?.text;
				if (responsavelEncontrado) {
					this.responsavelDelegado = responsavelEncontrado;
				} else {
					this.responsavelDelegado = '';
				}
			} else {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "warning",
					text: res.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		})
	}

	public delegar() {
		this.solicitacaoTecnicaService
			.delegarItem(this.item.id, this.responsavelDelegacao)
			.then((res) => {
				if (res.sucesso) {
					this.dialogRef.close();
					Swal.fire({
						toast: true,
						position: "top-end",
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
						icon: "success",
						text: res.mensagem.descricao,
					});
				} else {
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "warning",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			});
	}

	excluir(): void {
		Swal.fire({
			title: 'Confirmação',
			text: 'Tem certeza que deseja excluir o Responsável Delegado?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Sim',
			cancelButtonText: 'Não'
		}).then((result) => {
			if (result.isConfirmed) {
				this.solicitacaoTecnicaService
				.excluirDelegacaoItem(this.item.id)
				.then((res) => {
					if (res.sucesso) {
						this.dialogRef.close();
						Swal.fire({
							toast: true,
							position: "top-end",
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
							icon: "success",
							text: res.mensagem.descricao,
						});
					} else {
						Swal.fire({
							toast: true,
							position: "top-end",
							icon: "warning",
							text: res.mensagem.descricao,
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}
				});
			}
		});
	}

	public fechar() {
		this.dialogRef.close();
	}
}
